import {groq} from 'next-sanity';

import {BLOCK_TYPE_COOKIE_DECLARATION} from '@/components/content-blocks/cookie-declaration/constants';
import type {CookieDeclarationFragment} from '@/components/content-blocks/cookie-declaration/query';
import {COOKIE_DECLARATION_FRAGMENT} from '@/components/content-blocks/cookie-declaration/query';
import {BLOCK_TYPE_LINK_LIST_SELECTION} from '@/components/content-blocks/link-list-selection/constants';
import type {LinkListSelectionFragment} from '@/components/content-blocks/link-list-selection/query';
import {LINK_LIST_SELECTION_FRAGMENT} from '@/components/content-blocks/link-list-selection/query';
import {BLOCK_TYPE_DOCUMENT_LIST_SELECTION} from '@/modules/page/sanity/content-blocks/document-list-selection-container/constants';
import type {DocumentListSelectionFragmentType} from '@/modules/page/sanity/content-blocks/document-list-selection-container/query';
import {DOCUMENT_LIST_SELECTION_FRAGMENT} from '@/modules/page/sanity/content-blocks/document-list-selection-container/query';
import type {GallerySchema} from '@/modules/page/sanity/content-blocks/gallery-container/schema';
import {BLOCK_TYPE_TEXT} from '@/modules/page/sanity/content-blocks/text-container/constants';
import type {TextSectionFragmentType} from '@/modules/page/sanity/content-blocks/text-container/query';
import {TEXT_SECTION_FRAGMENT} from '@/modules/page/sanity/content-blocks/text-container/query';
import {BLOCK_TYPE_TEXT_WITH_IMAGE_SPLIT} from '@/modules/page/sanity/content-blocks/text-with-image-split-container/constants';
import type {TextWithImageSplitFragment} from '@/modules/page/sanity/content-blocks/text-with-image-split-container/query';
import {TEXT_WITH_IMAGE_SPLIT_FRAGMENT} from '@/modules/page/sanity/content-blocks/text-with-image-split-container/query';
import {BLOCK_TYPE_PERSON_LIST_SELECTION} from '@/modules/person/sanity/person-list-selection-container/constants';
import type {PersonListSelectionFragment} from '@/modules/person/sanity/person-list-selection-container/query';
import {PERSON_LIST_SELECTION_FRAGMENT} from '@/modules/person/sanity/person-list-selection-container/query';
import {BLOCK_TYPE_PRODUCT_LIST_ALL} from '@/modules/product/sanity/product-list-all-container/constants';
import type {ProductListAllFragment} from '@/modules/product/sanity/product-list-all-container/query';
import {PRODUCT_LIST_ALL_FRAGMENT} from '@/modules/product/sanity/product-list-all-container/query';

export const CONTENT_BLOCK_FRAGMENT = groq`
	...,

	// Klart foundation
	_type == "${BLOCK_TYPE_TEXT}" => {
		${TEXT_SECTION_FRAGMENT}
	},
	_type == "${BLOCK_TYPE_TEXT_WITH_IMAGE_SPLIT}" => {
		${TEXT_WITH_IMAGE_SPLIT_FRAGMENT}
	},
	_type == "${BLOCK_TYPE_DOCUMENT_LIST_SELECTION}" => {
		${DOCUMENT_LIST_SELECTION_FRAGMENT}
	},

	_type == "${BLOCK_TYPE_LINK_LIST_SELECTION}" => {
		${LINK_LIST_SELECTION_FRAGMENT}
	},

	// Product
	_type == "${BLOCK_TYPE_PRODUCT_LIST_ALL}" => {
		${PRODUCT_LIST_ALL_FRAGMENT}
	},

	// Person extension
	_type == "${BLOCK_TYPE_PERSON_LIST_SELECTION}" => {
		${PERSON_LIST_SELECTION_FRAGMENT}
	},

	_type == "${BLOCK_TYPE_COOKIE_DECLARATION}" => {
		${COOKIE_DECLARATION_FRAGMENT}
	},
`;

export type ContentBlockFragment =
	| TextSectionFragmentType
	| TextWithImageSplitFragment
	| GallerySchema
	| DocumentListSelectionFragmentType
	| ProductListAllFragment
	| PersonListSelectionFragment
	| LinkListSelectionFragment
	| CookieDeclarationFragment;
